<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import AgentSelector from '../AgentSelector.vue';
import { useVuelidate } from '@vuelidate/core';

export default {
  components: {
    PageHeader,
    AgentSelector,
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      selectedAgents: [],
      // Map { agentId -> role }
      agentRoles: {},
      isCreating: false,
    };
  },

  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
    }),

    teamId() {
      return this.$route.params.teamId;
    },
    headerTitle() {
      return this.$t('TEAMS_SETTINGS.ADD.TITLE', {
        teamName: this.currentTeam.name,
      });
    },
    currentTeam() {
      return this.$store.getters['teams/getTeam'](this.teamId);
    },
  },

  mounted() {
    this.$store.dispatch('agents/get');
  },

  methods: {
    updateSelectedAgents(newAgentList) {
      this.v$.selectedAgents.$touch();
      this.selectedAgents = [...newAgentList];
      // Limpiar roles de agentes deseleccionados
      const newRoles = {};
      newAgentList.forEach(id => {
        newRoles[id] = this.agentRoles[id] || 'member';
      });
      this.agentRoles = newRoles;
    },
    updateAgentRole(agentId, role) {
      this.agentRoles = { ...this.agentRoles, [agentId]: role };
    },
    async addAgents() {
      this.isCreating = true;
      const { teamId, selectedAgents, agentRoles } = this;

      const agentsWithRoles = selectedAgents.map(id => ({
        id,
        role: agentRoles[id] || 'member',
      }));
      // eslint-disable-next-line no-console
      console.log('[AddAgents] enviando agentsWithRoles:', agentsWithRoles);

      try {
        await this.$store.dispatch('teamMembers/create', {
          teamId,
          agentsWithRoles,
        });
        router.replace({
          name: 'settings_teams_finish',
          params: {
            page: 'new',
            teamId,
          },
        });
        this.$store.dispatch('teams/get');
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6 flex flex-col min-h-0">
    <form class="flex flex-col flex-1 min-h-0" @submit.prevent="addAgents">
      <div class="w-full flex-shrink-0">
        <PageHeader
          :header-title="headerTitle"
          :header-content="$t('TEAMS_SETTINGS.ADD.DESC')"
        />
      </div>

      <div class="w-full flex-1 min-h-0 flex flex-col">
        <div v-if="v$.selectedAgents.$error" class="flex-shrink-0">
          <p class="error-message pb-2">
            {{ $t('TEAMS_SETTINGS.ADD.AGENT_VALIDATION_ERROR') }}
          </p>
        </div>
        <AgentSelector
          :agent-list="agentList"
          :selected-agents="selectedAgents"
          :update-selected-agents="updateSelectedAgents"
          :agent-roles="agentRoles"
          :update-agent-role="updateAgentRole"
          :is-working="isCreating"
          :submit-button-text="$t('TEAMS_SETTINGS.ADD.BUTTON_TEXT')"
        />
      </div>
    </form>
  </div>
</template>
